"use client";

import React from "react";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function IdentityAndMethod() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}